import React from 'react';

/**
 * In-page tab row — collapses to a native select on narrow viewports (asset detail, etc.).
 */
export default function PageTabRow({ tabs, active, onChange, ariaLabel = 'Page sections' }) {
  return (
    <>
      <div className="md:hidden">
        <label htmlFor="page-tab-select" className="sr-only">{ariaLabel}</label>
        <select
          id="page-tab-select"
          value={active}
          onChange={(e) => onChange(e.target.value)}
          className="ga-input w-full"
        >
          {tabs.map((t) => (
            <option key={t.id} value={t.id}>
              {t.label}{t.badge ? ` (${t.badge})` : ''}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden md:block border-b border-ga-border-subtle">
        <div className="flex gap-1 overflow-x-auto [scrollbar-width:thin]">
          {tabs.map((t) => {
            const Icon = t.icon;
            return (
              <button
                key={t.id}
                type="button"
                onClick={() => onChange(t.id)}
                className={`inline-flex shrink-0 items-center gap-2 whitespace-nowrap border-b-2 px-4 py-3 text-sm font-medium transition-colors ${
                  active === t.id
                    ? 'border-ga-primary text-ga-primary'
                    : 'border-transparent text-ga-text-muted hover:text-ga-text-primary'
                }`}
              >
                {Icon && <Icon className="h-4 w-4" aria-hidden />}
                {t.label}
                {t.badge ? (
                  <span className="inline-flex min-w-5 items-center justify-center rounded-ga-full bg-ga-danger px-1.5 py-0.5 text-[10px] font-bold leading-none text-ga-text-on-primary">
                    {t.badge > 99 ? '99+' : t.badge}
                  </span>
                ) : null}
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
}
